import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    startLoginEmailPassword
} from '../../actions/auth';
import minegocio from '../../imgs/logo-mi-negocio-f.png'
import seccion from '../../imgs/seccion_amarilla.png'
import { useLocation } from "react-router-dom"
import { makeGET, makePOST } from '../../helpers/makeRequest';
import Swal from 'sweetalert2';

export const ResetScreen = () => {
    const dispatch = useDispatch()
    const search = useLocation().search;
    const { loading } = useSelector(state => state.ui);
    const [passShowedLogin, setPassShowedLogin] = useState(false)
    const [passShowedLogin1, setPassShowedLogin1] = useState(false)
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [password1, setPassword1] = useState('')
    const [countdown, setCountdown] = useState(3)
    const handleLogin = async (e) => {
        e.preventDefault();
        if ((password != password1)) {
            Swal.fire('Error', 'Las contraseñas deben ser iguales.', 'error')
        }
        if (!validarCadena(password) || !validarCadena(password1)) {
            Swal.fire('Error', 'Las contraseñas deben contener al menos 8 caracteres, una mayúscula y un número.', 'error')
        }

        try {
            const token = new URLSearchParams(search).get("token")
            const resp = await makePOST("auth/resetPassword", { token, password, password1 })

            if (resp?.data?.username) {
                Swal.fire("Éxito", "Iniciando sesión", 'success')
                setTimeout(() => {
                    Swal.close()
                    dispatch(startLoginEmailPassword(resp?.data?.username, password))
                }, 1000);
            }
        } catch (e) {
            console.log(e)
        }

        //dispatch(startLoginEmailPassword(email, password));
    }

    const validarCadena = (cadena) => {
        const tieneLongitudMinima = cadena.length >= 8;
        const tieneMayuscula = /[A-Z]/.test(cadena);
        const tieneNumero = /\d/.test(cadena);

        return tieneLongitudMinima && tieneMayuscula && tieneNumero;
    }


    const verifyToken = async (token) => {
        try {
            const resp = await makeGET("auth/verifyToken?token=" + token)
            if (resp?.data?.message != "Éxito") {
                Swal.fire('Error', 'Ocurrió un error.', 'error')
            }
        } catch (e) {
            Swal.fire('Error', 'Ocurrió un error.', 'error')
        }
    }



    useEffect(() => {
        const token = new URLSearchParams(search).get("token");
        verifyToken(token)
    }, [])

    return (
        <>
            <div className='row p-3 pl-4' style={{ height: "100vh" }}>
                <div className='col-12 d-flex justify-content-center'>
                    <div className='text-center bg-white p-2' style={{ maxWidth: "300px", height: "fit-content", borderRadius: "10px" }}>
                        <div className='pt-3 mt-3'>
                            <img src={seccion} className="img-fluid"
                                alt="Task logo" width="70%" style={{ borderRadius: "10px" }}
                            />
                        </div>
                        <div className='pt-1'>
                            <img src={minegocio} className="img-fluid"
                                alt="Task logo" width="70%" style={{ borderRadius: "10px" }}
                            />
                            <p>
                                Para iniciar sesión, debes ingresar una contraseña.
                                <br /> Debe tener al menos 8 caracteres, una letra mayúscula y un número.
                            </p>
                        </div>
                        <form onSubmit={handleLogin}>
                            <div className="form-outline mt-4 mb-4 text-center">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text"
                                            style={{ color: 'black', background: '#ffd900', borderColor: '#ffd900' }}>
                                            <i className="fas fa-key"></i>
                                        </span>
                                    </div>
                                    <input
                                        type={passShowedLogin1 ? "text" : "password"}
                                        placeholder="Contraseña"
                                        name="password1"
                                        autoCapitalize="off"
                                        autoCorrect="off"
                                        className="form-control form-control-lg"
                                        value={password1}
                                        onChange={e => setPassword1(e.target.value)}
                                    />
                                    <div className="input-group-append">
                                        <button className="btn" type="button"
                                            style={{ color: 'black', background: '#ffd900', borderColor: '#ffd900' }}
                                            onClick={() => setPassShowedLogin1(!passShowedLogin1)}>
                                            <i className={passShowedLogin1 ? "fa fa-eye-slash" : "fa fa-eye"}
                                                aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>

                            </div>
                            <div className="form-outline mb-3 text-center">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text"
                                            style={{ color: 'black', background: '#ffd900', borderColor: '#ffd900' }}>
                                            <i className="fas fa-key"></i>
                                        </span>
                                    </div>
                                    <input
                                        type={passShowedLogin ? "text" : "password"}
                                        placeholder="Confirma tu contraseña"
                                        name="password"
                                        autoCapitalize="off"
                                        autoCorrect="off"
                                        className="form-control form-control-lg"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                    />
                                    <div className="input-group-append">
                                        <button className="btn" type="button"
                                            style={{ color: 'black', background: '#ffd900', borderColor: '#ffd900' }}
                                            onClick={() => setPassShowedLogin(!passShowedLogin)}>
                                            <i className={passShowedLogin ? "fa fa-eye-slash" : "fa fa-eye"}
                                                aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center text-lg-start mt-4 mb-2 pt-2">
                                <button type="submit" className="btn btn-primary btn-large"
                                    disabled={!validarCadena(password) || !validarCadena(password1) || (password != password1)}
                                    style={{
                                        'paddingLeft': '2.5rem', 'paddingRight': '2.5rem', fontSize: '18px',
                                        color: 'black', background: '#ffd900', borderColor: '#ffd900'
                                    }}>
                                    Establecer contraseña
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}